import React, { useState, useEffect } from 'react'
import slaRepository from '../SlaRepository'
import moment from 'moment'
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import { secondsToStringTimer } from '../../../utils/Formatter'
import DownloadIcon from '@material-ui/icons/CloudDownload'
import { Typography, Tooltip, IconButton } from '@material-ui/core'
import { downloadCsv } from '../../../utils/DownloadCsv'
import { BadgeStatus } from '../../Solicitacoes/components'
import { useHistory } from 'react-router-dom'
import abbreviate from 'abbreviate-name'
import useQueryFilter from '../useQueryFilter'

const useStyles = makeStyles(theme => ({
  pd: {
    padding: theme.spacing(2)
  },
  row: {
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: 'rgba(0, 0, 0, 0.04)'
    }
  },
  tooltip: {
    marginTop: -theme.spacing(3)
  },
  parent: {
    marginTop: theme.spacing(1),
    overflowY: 'auto',
    transform: 'rotateX(180deg)'
  },
  child: {
    transform: 'rotateX(180deg)'
  }
}))

const TablePendenteGestorAtual = ({ setQuantidade, ...props }) => {
  const classes = useStyles()
  const [data, setData] = useState([])
  const history = useHistory()
  const [query] = useQueryFilter(props.location.search)

  useEffect(() => {
    async function fetchData() {
      const response = await slaRepository.pendenteGestorAtual({
        empresaId: query.empresaId
      })
      if (response.ok) {
        setData(response.data)
        setQuantidade(response.data.length)
      }
    }

    fetchData()
    const interval = setInterval(fetchData, 1000 * 30)
    return () => clearInterval(interval)
  }, [setQuantidade, query])

  const handleClick = solicitacaoId => {
    history.push(`/solicitacoes/${solicitacaoId}`)
  }

  const onDownloadClick = async () => {
    await downloadCsv(
      data,
      {
        fields: {
          tempo: {
            label: 'Tempo',
            format: value => secondsToStringTimer(value)
          },
          tempototal: {
            label: 'Tempo Total',
            format: value => secondsToStringTimer(value)
          }
        }
      },
      true,
      true,
      'Pendete Gestor Atual'
    )
  }

  return (
    <Grid item xs={12}>
      <Paper>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
        >
          <Grid item sm={11}>
            <Typography variant="h6" className={classes.pd}>
              Fila atual de solicitações pendentes gestores
            </Typography>
          </Grid>
          <Grid item sm={1}>
            <Grid container direction="row" justifyContent="center">
              {data.length > 0 && (
                <Tooltip title="Baixar lista" aria-label="Baixar lista">
                  <IconButton size="small" onClick={onDownloadClick}>
                    <DownloadIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Grid>
          </Grid>
        </Grid>
        <div className={classes.parent}>
          <Table className={classes.child}>
            <TableHead>
              <TableRow>
                <TableCell width="5%" align="center">
                  Solicitação
                </TableCell>
                <TableCell width="10%" align="center">
                  Status
                </TableCell>
                <TableCell width="15%" align="center">
                  Centro de Custo
                </TableCell>
                <TableCell width="15%" align="center">
                  Embarcador
                </TableCell>
                <TableCell width="15%" align="center">
                  Motorista
                </TableCell>
                <TableCell width="10%" align="center">
                  Data Criação
                </TableCell>
                <Tooltip
                  classes={{ popper: classes.tooltip }}
                  title="Tempo em pendente Monitoramento desde a última análise"
                >
                  <TableCell width="15%" align="center">
                    Tempo
                  </TableCell>
                </Tooltip>
                <Tooltip
                  classes={{ popper: classes.tooltip }}
                  title="Tempo total que ficou em pendente Monitoramento desde sua criação"
                >
                  <TableCell width="15%" align="center">
                    Tempo Total
                  </TableCell>
                </Tooltip>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map(row => (
                <TableRow
                  classes={{ root: classes.row }}
                  key={row.solicitacaoid}
                  onClick={() => handleClick(row.solicitacaoid)}
                >
                  <TableCell align="center">{row.solicitacaoid}</TableCell>
                  <TableCell align="center">
                    <BadgeStatus status={row.status} />
                  </TableCell>
                  <TableCell align="center">{row.centrocusto}</TableCell>
                  <TableCell align="center">
                    {row.embarcador ? abbreviate(row.embarcador) : ' '}
                  </TableCell>
                  <TableCell align="center">
                    {abbreviate(row.motorista)}
                  </TableCell>
                  <TableCell align="center">
                    {moment(row.createdat).format('DD/MM/YYYY HH:mm')}
                  </TableCell>
                  <TableCell align="center">
                    {secondsToStringTimer(row.tempo)}
                  </TableCell>
                  <TableCell align="center">
                    {secondsToStringTimer(row.tempototal)}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </Paper>
    </Grid>
  )
}

export default React.memo(TablePendenteGestorAtual)
